import axios from "axios";
import { API_BASE_URL } from "./config";
import {
  installAuthInterceptors,
  installErrorNormalization,
} from "./interceptors";
import { installHttpLogging } from "./http-logging";

/**
 * Public / unauthenticated calls (no bearer). Still sends credentials so cookie-setting auth
 * routes (login, refresh, accept) work and the dz_refresh cookie flows on /api/v1/auth/*.
 */
export const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

/**
 * Authenticated calls. The request interceptor attaches the in-memory access token; the
 * response interceptor runs the 401→refresh→retry flow. Callers get a normalized ApiError.
 */
export const privateApi = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

// Order matters: logging is installed FIRST so its response handler observes the RAW error and
// re-throws. THEN error handling runs: the public `api` gets plain normalization to ApiError;
// `privateApi` gets the auth interceptor, which runs the 401→refresh flow AND normalizes on
// every path. So callers of BOTH instances always receive a typed ApiError.
installHttpLogging(api);
installErrorNormalization(api);
installHttpLogging(privateApi);
installAuthInterceptors(privateApi);
